import { TypesValidations } from 'constants/enums'

const revertBooleanApiValue = (value: boolean) => {
  return value ? TypesValidations.YES : TypesValidations.NO
}

export { revertBooleanApiValue }
